import Manager from './Manager';

export default abstract class AbstractModule {
  abstract getRoutes(): any[];

  constructor() {
    window.addEventListener('add-routes', () => {
      Manager.getInstance().addRoutes(this.getRoutes());
    });
  }
}
